var Mustache, StepTwoCMSBaseView, StepTwoV2CMSView, SupportMainContentWrapperView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportMainContentWrapperView = require('../../main_content_view');

StepTwoCMSBaseView = require('./base_view');

Mustache = require('../../../../../../core/frontend/vendor_modules/mustache-0.7.2');

StepTwoV2CMSView = (function(superClass) {
  extend(StepTwoV2CMSView, superClass);

  function StepTwoV2CMSView() {
    return StepTwoV2CMSView.__super__.constructor.apply(this, arguments);
  }

  StepTwoV2CMSView.prototype.initialize = function() {
    return StepTwoCMSBaseView.prototype.initialize.apply(this, arguments);
  };

  StepTwoV2CMSView.prototype.render = function() {
    var content, mainContentWrappper;
    StepTwoCMSBaseView.prototype.render.call(this);
    mainContentWrappper = new SupportMainContentWrapperView;
    mainContentWrappper.render((function(_this) {
      return function(contentWrapper) {
        _this.fetchFlexibleContactChannels(contentWrapper);
        return _this.fetchAndRenderCategory(contentWrapper);
      };
    })(this));
    this.$el.append(mainContentWrappper.el);
    this.renderStepTwoActions();
    content = Groupon.Support.ContentModel.getContent();
    if (content != null) {
      return this.renderContent(content);
    }
  };

  StepTwoV2CMSView.prototype.renderContent = function(content) {
    var attributeValue, category_id, sub_category_id, text;
    this.spinnerView.hide();
    if (!(((content != null ? content.text : void 0) != null) && content.text !== "")) {
      this.helpContentLoadError();
      return;
    }
    text = Mustache.to_html(content.text, Groupon.Support.ContentModel.getContentObject());
    category_id = this.getCategoryId();
    sub_category_id = this.getSubCategoryId();
    attributeValue = "hw__" + country.name + "__" + category_id + "__" + sub_category_id + "__" + content.id;
    this.renderContentData(text, attributeValue);
    return this.enableStepActions();
  };

  StepTwoV2CMSView.prototype.clearContentElement = function() {
    this.clearElement('.cms-content');
    this.$('.content-section').hide();
    return this.clearStepThreeIfPresent();
  };

  StepTwoV2CMSView.prototype.clearStepThreeIfPresent = function() {
    if ((Groupon.Support.CURRENTVIEW != null) && Groupon.Support.CURRENTVIEW.id !== this.id) {
      Groupon.Support.HelpWizardViewManager.removeStackedViewsAndUpdateCurrentView(this);
      return propagateEventBeforeReplacingElements(function() {
        return Backbone.history.navigate("#select-issue", {
          trigger: false
        });
      });
    }
  };

  StepTwoV2CMSView.prototype.renderCategory = function(contentWrapper) {
    var contentCategory;
    this.categoryRendered = true;
    contentWrapper.html(toHtml(this.categoryTemplate, {
      categories: this.getCategoryList(),
      isFilterDropdowns: true,
      showVerticalPageFlow: true
    }, this.I18nScope));
    contentCategory = Groupon.Support.ContentModel.getCategory();
    if (contentCategory && contentCategory !== null) {
      $(".category", contentWrapper).val(contentCategory.id);
      $(".category option[value='" + contentCategory.id + "']", contentWrapper).attr("selected", "selected");
      return this.renderSubCategory(contentWrapper);
    }
  };

  StepTwoV2CMSView.prototype.enableStepActions = function() {
    return this.handleDisplayOfTicketDirectionButtons();
  };

  StepTwoV2CMSView.prototype.helpContentLoadError = function() {
    var category_id, sub_category_id;
    this.spinnerView.hide();
    category_id = this.getCategoryId();
    sub_category_id = this.getSubCategoryId();
    this.clearElement('.cms-content');
    this.$('.content-section').hide();
    this.disableAllButton();
    return Backbone.history.navigate('#contact-us', {
      trigger: true
    });
  };

  StepTwoV2CMSView.prototype.renderContentData = function(text, attributeValue) {
    this.$('.inbenta-content').empty();
    this.$('.content-section').show();
    this.$('.cms-content').attr("data-bhw", attributeValue);
    return this.$('.cms-content').html(text);
  };

  StepTwoV2CMSView.prototype.filterDropdowns = function(dropdowns, allTags) {
    return _.filter(dropdowns, (function(_this) {
      return function(item) {
        if (item.tagLines == null) {
          return true;
        }
        return _.some(item.tagLines, function(tl) {
          var commonTags, filterTags;
          filterTags = tl.split(",");
          commonTags = _.intersection(allTags, filterTags);
          return commonTags.length === allTags.length;
        });
      };
    })(this));
  };

  StepTwoV2CMSView.prototype.getCategoryList = function() {
    var allTags, dropdowns;
    dropdowns = this.getDropdowns();
    dropdowns = this.addTaglinesToCategories(dropdowns);
    if (this.tagLine != null) {
      allTags = this.tagLine.split(",");
      dropdowns = this.filterDropdowns(dropdowns, allTags);
    }
    return _.sortBy(dropdowns, function(category) {
      return parseInt(category.weight);
    });
  };

  StepTwoV2CMSView.prototype.getSubCategoryList = function() {
    var allTags, category, dropdowns, subCategories;
    dropdowns = this.getDropdowns();
    category = _.find(dropdowns, function(item) {
      return item.id === Groupon.Support.ContentModel.getCategory().id;
    });
    subCategories = category.subCategories;
    if (this.tagLine != null) {
      allTags = this.tagLine.split(",");
      subCategories = this.filterDropdowns(subCategories, allTags);
    }
    return _.sortBy(subCategories, function(s) {
      return parseInt(s.weight);
    });
  };

  StepTwoV2CMSView.prototype.addTaglinesToCategories = function(dropdowns) {
    _.each(dropdowns, function(category) {
      var categoryTaglines;
      categoryTaglines = [];
      _.each(category.subCategories, function(subCategory) {
        return categoryTaglines.push(subCategory.tagLines);
      });
      categoryTaglines = _.uniq(_.flatten(categoryTaglines));
      return category.tagLines = categoryTaglines;
    });
    return dropdowns;
  };

  StepTwoV2CMSView.prototype.shouldFetchFlexibleContactChannels = function() {
    return !this.flexibleContactChannelModel.hasContactChannels();
  };

  StepTwoV2CMSView.prototype.enableTicketDirectionButton = function() {};

  return StepTwoV2CMSView;

})(StepTwoCMSBaseView);

module.exports = StepTwoV2CMSView;

//# sourceMappingURL=data:application/json;base64,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
